import { z } from 'zod';
/**
 * Portal (landing) client env — no gateway URL required.
 * Usage: `parsePortalClientEnv(import.meta.env)` from apps/landing.
 */
export const portalClientEnvSchema = z.object({
    VITE_SUPABASE_URL: z.string().url(),
    VITE_SUPABASE_ANON_KEY: z.string().min(1),
});
export function parsePortalClientEnv(raw) {
    const result = portalClientEnvSchema.safeParse(raw);
    if (!result.success) {
        const issues = result.error.issues
            .map((i) => `  ${i.path.join('.')}: ${i.message}`)
            .join('\n');
        throw new Error(`Invalid portal client environment variables:\n${issues}`);
    }
    return result.data;
}
//# sourceMappingURL=schema.portal-client.js.map